const baseClass = '.js-modal';
const modals = document.querySelectorAll(baseClass);

const onKeyDown = (item) => (event) => {
  if (event.key === 'Escape') {
    item.setAttribute('aria-hidden', 'true');

    window.removeEventListener('keydown', onKeyDown, true);
  }
};

const handleClick = (modal) => (event) => {
  event.preventDefault();

  const item = modal.querySelector(`${baseClass}-item`);

  if (item.getAttribute('aria-hidden') === 'true') {
    item.setAttribute('aria-hidden', 'false');

    window.addEventListener('keydown', onKeyDown(item));
  } else {
    item.setAttribute('aria-hidden', 'true');
  }
};

modals.forEach((modal) => {
  const trigger = modal.querySelector(`${baseClass}-trigger`);
  const closes = modal.querySelectorAll(`${baseClass}-close`);

  trigger.addEventListener('click', handleClick(modal));

  closes.forEach((close) => {
    close.addEventListener('click', handleClick(modal));
  });
});
